/*
 * @Author: liyifan 
 * @Date: 2025-11-21 16:07:41 
 * @Last Modified by: liyifan
 * @Last Modified time: 2025-12-02 14:13:53
 * @description: V5 首页图文产品手风琴组件
 */
if (!customElements.get("v5-index-accordion")) {
  class V5IndexAccordion extends HTMLElement {
    constructor() {
      super();
      this.DOM = {
        addToCartList: this.querySelectorAll("[accordion-add-to-cart]") || [],
        toggles: this.querySelectorAll(".accordion-toggle"),
        pictures: this.querySelectorAll(".accordion-image"),
        imageContainer: this.querySelector(".scence-images"),
        accordionCards: this.querySelectorAll(".accordion-card"),
      };

      this.data = {
        currentVariantId: this.getAttribute("data-curr_variant_id"),
        blockId: this.getAttribute("data-block_id"),
        variantListStr: this.getAttribute("data-str"),
        imgRatios: {}, // 存储每张图片的宽高比例
      };

      this.toggleHandlers = [];
      this.cartHandlers = [];
    }

    connectedCallback() {
      this.initImageRatios();
      this.bindEvents();
      this.initCurrentCard();

      window.addEventListener("resize", this.resizeHandler);
    }

    disconnectedCallback() {
      this.unbindEvents();
      window.removeEventListener("resize", this.resizeHandler);
    }

    // 初始化每张图片的宽高比例
    initImageRatios() {
      this.DOM.pictures.forEach((el) => {
        const img = el.querySelector("img");
        if (!img) return;

        const setRatio = () => {
          this.data.imgRatios[el.dataset.id] =
            img.naturalHeight / img.naturalWidth;
        };

        if (img.complete && img.naturalWidth > 20) {
          // 已加载且不是占位图
          setRatio();
        } else {
          // 监听 lazyloaded 或 load 事件
          img.addEventListener("lazyloaded", setRatio, { once: true });
          img.addEventListener("load", setRatio, { once: true });
        }
      });
    }

    initCurrentCard() {
      const currentId = this.data.currentVariantId;
      const blockId = this.data.blockId;
      if (!currentId || !blockId) return;

      const currentCard = Array.from(this.DOM.accordionCards).find(
        (el) => el.dataset.id === currentId && el.dataset.index === blockId
      );
      if (!currentCard) return;

      currentCard.classList.add("accordion-card-select");
      const content = currentCard.querySelector(".accordion-content");
      content.style.height = content.scrollHeight + "px";
      content.style.opacity = 1;
      content.style.transform = "translateY(0)";

      this.DOM.pictures.forEach((el) => {
        el.classList.toggle(
          "accordion-image-select",
          el.dataset.id === currentId
        );
      });

      content.addEventListener("transitionend", function handler(e) {
        if (e.propertyName === "height") {
          content.style.height = "auto";
          content.removeEventListener("transitionend", handler);
        }
      });
    }

    updateContent() {
      const id = this.data.currentVariantId;
      this.DOM.accordionCards.forEach((el) =>
        el.classList.toggle("accordion-card-select", el.dataset.id == id )
      );
      this.DOM.pictures.forEach((el) =>
        el.classList.toggle("accordion-image-select", el.dataset.id == id)
      );
    }

    bindEvents() {
      this.DOM.toggles.forEach((el) => {
        const handler = () => this.toggleCard(el);
        el.addEventListener("click", handler);
        this.toggleHandlers.push({ el, handler });
      });

      this.DOM.addToCartList.forEach((item) => {
        const handler = () => this.addToCart(item);
        item.addEventListener("click", handler);
        this.cartHandlers.push({ el: item, handler });
      });
    }

    unbindEvents() {
      this.toggleHandlers.forEach(({ el, handler }) =>
        el.removeEventListener("click", handler)
      );
      this.cartHandlers.forEach(({ el, handler }) =>
        el.removeEventListener("click", handler)
      );
      this.toggleHandlers = [];
      this.cartHandlers = [];
    }

    toggleCard(el) {
      console.log("toggleCard", el);
      const parentEl = el.parentElement;
      if (parentEl.classList.contains("accordion-card-select")) return;

      const activeCard = this.querySelector(".accordion-card-select");
      if (activeCard) {
        const content = activeCard.querySelector(".accordion-content");
        content.style.height = content.scrollHeight + "px";
        content.offsetHeight;
        requestAnimationFrame(() => (content.style.height = "0"));
        activeCard.classList.remove("accordion-card-select");
      }

      parentEl.classList.add("accordion-card-select");
      const content = parentEl.querySelector(".accordion-content");
      const height = content.scrollHeight;
      content.style.height = "0";
      content.offsetHeight;
      requestAnimationFrame(() => (content.style.height = height + "px"));

      content.addEventListener(
        "transitionend",
        function handler(e) {
          if (e.propertyName === "height") {
            if (parentEl.classList.contains("accordion-card-select"))
              content.style.height = "auto";
            content.removeEventListener("transitionend", handler);
          }
        }.bind(this),
        { once: true }
      );

      // 监听图片加载，兜底刷新高度
      const imgs = content.querySelectorAll("img");
      imgs.forEach((img) => {
        img.addEventListener("load", () => {
          if (parentEl.classList.contains("accordion-card-select")) {
            content.style.height = content.scrollHeight + "px";
            requestAnimationFrame(() => (content.style.height = "auto"));
          }
        });
      });

      this.data.currentVariantId = parentEl.dataset.id;
      this.updateContent();
      const { id, title } = el.dataset;
      const gaParams = {
        module: "Product Switcher",
        position: title || "",
        button_name: "Open",
      }
      gaPushDataLayer("5.0_homepage_user_clicks", gaParams);
    }

    async addToCart(el) {
      el.classList.add("btn--loading");
      const cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      try {
        const { id, module, position, button_name } = el.dataset;
        const response = await fetch("/cart/add.js", {
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        const data = await response.json();
        if (cart?.renderContents) cart.renderContents(data);
        else window.location.href = "/cart";

        const gaParams = {
          module: module || "Product Switcher",
          position: position || "",
          button_name: button_name || "Add to Cart",
        }
        gaPushDataLayer("5.0_homepage_user_clicks", gaParams);
        
      } catch (e) {
        const msg = await e.json?.();
        msg?.message && pushErrorMessage(msg.message);
      } finally {
        el.classList.remove("btn--loading");
        cart?.classList.contains("is-empty") &&
          cart.classList.remove("is-empty");
      }
    }
  }

  customElements.define("v5-index-accordion", V5IndexAccordion);
}
